import { useEffect, useState } from "react";
import { remainingSmsSeconds } from "./loginPolicy";

/** 每个短信场景共享冷却时间，存储不可用时退化为当前页面内计时。 */
export function useSmsCooldown(scene: "login" | "bind") {
  const key = `bomate:login:sms:${scene}`;
  const [deadline, setDeadline] = useState(() => {
    try {
      return Number(sessionStorage.getItem(key)) || 0;
    } catch {
      return 0;
    }
  });
  const [seconds, setSeconds] = useState(() => remainingSmsSeconds(deadline));
  const [sent, setSent] = useState(deadline > 0);
  useEffect(() => {
    const update = () => setSeconds(remainingSmsSeconds(deadline));
    update();
    if (!remainingSmsSeconds(deadline)) return;
    const timer = window.setInterval(update, 500);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", update);
    };
  }, [deadline]);
  /** 只有服务端确认发送成功或明确要求冷却后才开始计时。 */
  const start = (duration = 60) => {
    const next = Date.now() + Math.min(60, Math.max(1, duration)) * 1000;
    setDeadline(next);
    setSeconds(remainingSmsSeconds(next));
    setSent(true);
    try {
      sessionStorage.setItem(key, String(next));
    } catch {
      /* 隐私模式下保留内存计时。 */
    }
  };
  return { seconds, sent, start };
}
